export default __webpack_public_path__ + "static/media/back.44d6abc0.svg";